// Instruments
import { createStorage } from './createStorage';

export default createStorage('OTP');
export { createStorage };
